import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Redirect, Switch } from "react-router-dom";
import FullScreenModal from "./globals/core/Modal/Modal";
import AppRoute from "./globals/core/AppRoute/AppRoute";
import {
  authProtectedRoutes,
  publicRoutes,
  routeInterface,
} from "./globals/core/AppRoute/routes";
import { Alerts } from "./globals/core/Alerts/Alerts";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { logoutAction, setMe } from "./store/actions/authActions";
import { request } from "./globals/services/axios";
import { UsersService } from "./globals/services/users.service";

function App() {
  const { t } = useTranslation("common");
  const { token } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch();

  // Listen for token expiration events from axios interceptor
  useEffect(() => {
    const handleTokenExpired = () => {
      dispatch(logoutAction());
    };

    window.addEventListener("tokenExpired", handleTokenExpired);

    return () => {
      window.removeEventListener("tokenExpired", handleTokenExpired);
    };
  }, [dispatch]);

  //THIS USEEFFECT CALL FIRES EVERYTIME TOKEN IS UPDATED
  useEffect(() => {
    let clear: any;

    const clearSetTimeout = (c: any) => {
      if (c) window.clearTimeout(c);
    };

    const getMe = async () => {
      try {
        const _me = await UsersService().me();
        dispatch(setMe(_me));
      } catch (err) {
        console.error("Error getting user data:", err);
        dispatch(logoutAction());
      }
    };

    const afterLogin = async () => {
      if (token) {
        const decoded: any = jwt_decode(token);
        const exp = decoded.exp * 1000;
        const expireTime = new Date(exp);
        const nowTime = new Date();
        const timeUntilExpiry = expireTime.getTime() - nowTime.getTime();

        if (expireTime.getTime() < nowTime.getTime()) {
          console.log("Token is expired, logging out immediately");
          dispatch(logoutAction());
        } else {
          //SETTING UP ME ACCORDING TO THE TOKEN
          await getMe();

          // Maximum delay for setTimeout (24.8 days in milliseconds)
          const MAX_TIMEOUT = 2147483647;

          const checkExpiration = () => {
            const currentTime = new Date().getTime();
            if (currentTime >= exp) {
              console.log("Token expiration timeout triggered, logging out");
              dispatch(logoutAction());
              window.clearTimeout(clear);
            } else {
              // Set next check for the maximum allowed timeout
              const nextCheck = Math.min(exp - currentTime, MAX_TIMEOUT);
              clear = setTimeout(checkExpiration, nextCheck);
            }
          };

          // Start the first check
          clear = setTimeout(
            checkExpiration,
            Math.min(timeUntilExpiry, MAX_TIMEOUT)
          );
        }
      } else {
        console.log("No token present");
      }
    };
    afterLogin();
    return () => {
      clearSetTimeout(clear);
    };
  }, [token, dispatch]);

  return (
    <>
      <div dir={t("direction")} className={t("direction")}>
        <BrowserRouter>
          <Switch>
            {publicRoutes.map((route: routeInterface, idx: number) => (
              <AppRoute
                path={route.path}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                exact
              />
            ))}
            {authProtectedRoutes.map((route: routeInterface, idx: number) => (
              <AppRoute
                path={route.path}
                component={route.component}
                key={idx}
                isAuthProtected
                exact
              />
            ))}
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
        <FullScreenModal dir={t("direction")} />
        <Alerts />
      </div>
    </>
  );
}

export default App;
